var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jet-authentication-card",
    {
      scopedSlots: _vm._u([
        {
          key: "logo",
          fn: function () {
            return [_c("jet-authentication-card-logo")]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("jet-validation-errors", { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("jet-label", {
                attrs: { for: "first_name", value: "First Name" },
              }),
              _vm._v(" "),
              _c("jet-input", {
                staticClass: "mt-1 block w-full",
                attrs: {
                  id: "first_name",
                  type: "text",
                  required: "",
                  autofocus: "",
                  autocomplete: "first_name",
                },
                model: {
                  value: _vm.form.first_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "first_name", $$v)
                  },
                  expression: "form.first_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("jet-label", {
                attrs: { for: "last_name", value: "Last Name" },
              }),
              _vm._v(" "),
              _c("jet-input", {
                staticClass: "mt-1 block w-full",
                attrs: {
                  id: "last_name",
                  type: "text",
                  required: "",
                  autofocus: "",
                  autocomplete: "last_name",
                },
                model: {
                  value: _vm.form.last_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "last_name", $$v)
                  },
                  expression: "form.last_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("jet-label", { attrs: { for: "email", value: "Email" } }),
              _vm._v(" "),
              _c("jet-input", {
                staticClass: "mt-1 block w-full",
                attrs: { id: "email", type: "email", required: "" },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("jet-label", {
                attrs: { for: "password", value: "Password" },
              }),
              _vm._v(" "),
              _c("jet-input", {
                staticClass: "mt-1 block w-full",
                attrs: {
                  id: "password",
                  type: "password",
                  required: "",
                  autocomplete: "new-password",
                },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("jet-label", {
                attrs: {
                  for: "password_confirmation",
                  value: "Confirm Password",
                },
              }),
              _vm._v(" "),
              _c("jet-input", {
                staticClass: "mt-1 block w-full",
                attrs: {
                  id: "password_confirmation",
                  type: "password",
                  required: "",
                  autocomplete: "new-password",
                },
                model: {
                  value: _vm.form.password_confirmation,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password_confirmation", $$v)
                  },
                  expression: "form.password_confirmation",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.$page.props.jetstream.hasTermsAndPrivacyPolicyFeature
            ? _c(
                "div",
                { staticClass: "mt-4" },
                [
                  _c("jet-label", { attrs: { for: "terms" } }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center" },
                      [
                        _c("jet-checkbox", {
                          attrs: { name: "terms", id: "terms" },
                          model: {
                            value: _vm.form.terms,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "terms", $$v)
                            },
                            expression: "form.terms",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-2" }, [
                          _vm._v(
                            "\n                        I agree to the\n                        "
                          ),
                          _c(
                            "a",
                            {
                              staticClass:
                                "underline text-sm text-gray-600 hover:text-gray-900",
                              attrs: {
                                target: "_blank",
                                href: _vm.route("terms.show"),
                              },
                            },
                            [_vm._v("Terms of Service")]
                          ),
                          _vm._v(
                            "\n                        and\n                        "
                          ),
                          _c(
                            "a",
                            {
                              staticClass:
                                "underline text-sm text-gray-600 hover:text-gray-900",
                              attrs: {
                                target: "_blank",
                                href: _vm.route("policy.show"),
                              },
                            },
                            [_vm._v("Privacy Policy")]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center justify-end mt-4" },
            [
              _c(
                "Link",
                {
                  staticClass:
                    "underline text-sm text-gray-600 hover:text-gray-900",
                  attrs: { href: _vm.route("login") },
                },
                [_vm._v("\n                Already registered?\n            ")]
              ),
              _vm._v(" "),
              _c(
                "jet-button",
                {
                  staticClass: "ml-4",
                  class: { "opacity-25": _vm.form.processing },
                  attrs: { disabled: _vm.form.processing },
                },
                [_vm._v("\n                Register\n            ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }